class CartDrawer extends HTMLElement {
  constructor() {
    super()

    this.addEventListener('keyup', (evt) => evt.code === 'Escape' && this.close())
    this.addEventListener('click', (evt) => {
      if (evt.target.closest('#CartDrawer-Overlay')) this.close()
    })
    this.setHeaderCartIconAccessibility()
    this.setQuickOrderCartLink()

    setTimeout(()=>{
      console.log('Ready!');
      
      const event = new CustomEvent('cart:ui:updated');
      document.dispatchEvent(event);
    })
  }

  setHeaderCartIconAccessibility() {
    const cartLink = document.querySelector('#cart-icon-bubble')
    cartLink.setAttribute('role', 'button')
    cartLink.setAttribute('aria-haspopup', 'dialog')
    cartLink.addEventListener('click', (event) => {
      event.preventDefault()
      this.open(cartLink)
    })
    cartLink.addEventListener('keydown', (event) => {
      if (event.code.toUpperCase() === 'SPACE') {
        event.preventDefault()
        this.open(cartLink)
      }
    })
  }

  setQuickOrderCartLink() {
    const cartLink = document.querySelector('.quick-order-cart-link')
    if(cartLink) {
    cartLink.setAttribute('role', 'button')
    cartLink.setAttribute('aria-haspopup', 'dialog')
    cartLink.addEventListener('click', (event) => {
      event.preventDefault()
      this.open(cartLink)
    })
    cartLink.addEventListener('keydown', (event) => {
      if (event.code.toUpperCase() === 'SPACE') {
        event.preventDefault()
        this.open(cartLink)
      }
    })      
    }

  }

  open(triggeredBy) {
    if (triggeredBy) this.setActiveElement(triggeredBy)
    const cartDrawerNote = this.querySelector('[id^="Details-"] summary')
    if (cartDrawerNote && !cartDrawerNote.hasAttribute('role'))
      this.setSummaryAccessibility(cartDrawerNote)
    // here the animation doesn't seem to always get triggered. A timeout seem to help
    setTimeout(() => {
      this.classList.add('animate', 'active')
    })

    this.addEventListener(
      'transitionend',
      () => {
        const containerToTrapFocusOn = this.classList.contains('is-empty')
          ? this.querySelector('.drawer__inner-empty')
          : document.getElementById('CartDrawer')
        const focusElement =
          this.querySelector('.drawer__inner') || this.querySelector('.drawer__close')
        trapFocus(containerToTrapFocusOn, focusElement)
      },
      { once: true }
    )

    lockDrawerScroll()
  }

  close() {
    this.classList.remove('active')
    removeTrapFocus(this.activeElement)
    unlockDrawerScroll()
  }

  setSummaryAccessibility(cartDrawerNote) {
    cartDrawerNote.setAttribute('role', 'button')
    cartDrawerNote.setAttribute('aria-expanded', 'false')

    if (cartDrawerNote.nextElementSibling.getAttribute('id')) {
      cartDrawerNote.setAttribute('aria-controls', cartDrawerNote.nextElementSibling.id)
    }

    cartDrawerNote.addEventListener('click', (event) => {
      event.currentTarget.setAttribute(
        'aria-expanded',
        !event.currentTarget.closest('details').hasAttribute('open')
      )
    })

    cartDrawerNote.parentElement.addEventListener('keyup', onKeyUpEscape)
  }

  renderContents(parsedState) {
    this.querySelector('.drawer__inner').classList.contains('is-empty') &&
      this.querySelector('.drawer__inner').classList.remove('is-empty')
    this.productId = parsedState.id
    this.getSectionsToRender().forEach((section) => {
      const sectionHtml = parsedState.sections?.[section.id]
      if (sectionHtml == null || sectionHtml === '') return
      const sectionElement = section.selector
        ? document.querySelector(section.selector)
        : document.getElementById(section.id)
      if (!sectionElement) return
      if (section.id === 'cart-bundle-progress') {
        if (!sectionElement.closest('cart-drawer') && !sectionElement.closest('#CartDrawer')) return
      }
      sectionElement.innerHTML = this.getSectionInnerHTML(sectionHtml, section.selector)
    })

    // PDP bundle progress: update from add-to-cart response (no second fetch, no blink)
    const progressEl = document.getElementById('cart-bundle-progress')
    if (progressEl && !progressEl.closest('cart-drawer') && parsedState.sections) {
      const sectionWrapper = progressEl.closest('[id^="shopify-section-"]')
      if (sectionWrapper) {
        const sectionId = sectionWrapper.id.replace('shopify-section-', '')
        const sectionHtml = parsedState.sections[sectionId]
        if (sectionHtml) {
          const doc = new DOMParser().parseFromString(sectionHtml, 'text/html')
          const newProgress = doc.querySelector('#cart-bundle-progress')
          if (newProgress && typeof window.setProductBundleProgressContent === 'function') {
            window.setProductBundleProgressContent(progressEl, newProgress.innerHTML)
          }
        }
      }
    }

    setTimeout(() => {
      this.open()
    })
    

    const event = new CustomEvent('cart:ui:updated');
    document.dispatchEvent(event);

  }

  getSectionInnerHTML(html, selector = '.shopify-section') {
    return new DOMParser().parseFromString(html, 'text/html').querySelector(selector).innerHTML
  }

  getSectionsToRender() {
    return [
      {
        id: 'cart-drawer',
        selector: '#CartDrawer',
      },
      {
        id: 'cart-icon-bubble',
      },

      {
        id: 'cart-bundle-progress',
      },
    ]
  }

  getSectionDOM(html, selector = '.shopify-section') {
    return new DOMParser().parseFromString(html, 'text/html').querySelector(selector)
  }

  setActiveElement(element) {
    this.activeElement = element
  }
}

customElements.define('cart-drawer', CartDrawer)

class CartDrawerItems extends CartItems {
  getSectionsToRender() {
    return [
      {
        id: 'CartDrawer',
        section: 'cart-drawer',
        selector: '.drawer__inner',
      },
      {
        id: 'cart-icon-bubble',
        section: 'cart-icon-bubble',
        selector: '.shopify-section',
      },
    ]
  }
}

customElements.define('cart-drawer-items', CartDrawerItems)